import { Box, Button, Container, SvgIcon } from "@mui/material";
import axiosInstance from "app/axios";
import { useAppDispatch, useAppSelector } from "app/hooks";
import Header from "components/header/Header";
import HolzfinderList from "components/list/HolzfinderList";
import { getAgentUsers, selectAgentUsers, selectCurrentAgentId } from "features/agent/agentSlice";
import { setPageAgentUsersList, setRowsPerPageAgentUsersList } from "features/table/tableSlice";
import { selectUserRole } from "features/user/userSlice";
import { Add } from "icons";
import { UserRoles } from "interfaces/UserRoles";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface rowInterface {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  status: string;
  checked: boolean;
}
interface Props {
  page: number;
  rowsPerPage: number;
  agentListTotal: number;
}
// console.log(setRowsPerPageAgentUsersList)

const tableHeaderList: string[] = ["Vorname", "Nachname", "E-Mail", "Aktiv", "Bearbeiten"]


export default function AgentUsers(props: Props) {
  const { page = 0, rowsPerPage = 10, agentListTotal = 0 } = props

  const currentAgentId = useAppSelector(selectCurrentAgentId);

  const [rowData, setRowData] = useState<rowInterface[]>([]);
  const [searchQuery, setSearchQuery] = React.useState("");
  const agentUsers = useAppSelector(selectAgentUsers)
  const userRole = useAppSelector(selectUserRole)
  const dispatch = useAppDispatch();
  let navigate = useNavigate();


  const switchStatus = (id: string, newChecked: boolean) => {
    const newItems = rowData.map((row) => {
      if (row.id === id) {
        const payload: any = {};
        payload["status"] = row.status === "active" ? "inactive" : "active";
        axiosInstance.patch(`admin/users/${row.id}`, payload);

        return {
          ...row,
          checked: newChecked,
          status: row.status === "active" ? "inactive" : "active",
        };
      } else {
        return row;
      }
    });
    setRowData(newItems);
  };

  useEffect(() => {
    const receiveAgentUsersList = (resetSearch: boolean) => {
      if (resetSearch) setSearchQuery("")

      dispatch(
        getAgentUsers({
          items_per_page: rowsPerPage,
          page: page + 1,
          search: resetSearch ? undefined : searchQuery,
          agent_id: currentAgentId,
          role: UserRoles.Agent
        })
      );
    };
    // console.log(page, rowsPerPage, agentId, rowsPerPage)
    receiveAgentUsersList(false)

  }, [page, rowsPerPage, dispatch, currentAgentId, searchQuery]);


  useEffect(() => {
    // console.log(agentUsers)
    if (agentUsers) {
      const mappedData = agentUsers.map(

        (user) => ({
          id: user.id,
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          status: user.status,
          checked: user.status === "active" ? true : false,
        })
      );
      setRowData(mappedData);
    }
  }, [agentUsers])

  //solve list pagination at first load to zero
  useEffect(() => {
    dispatch(setPageAgentUsersList(0));
  }, [dispatch]);

  return (
    <Container sx={{ pt: 7 }} maxWidth="xl">
      <Box>
        <Header
          header="Userliste"
          actionButton1={
            <Button sx={{ backgroundColor: "#c0d904", color: "rgba(0,0,0,0.5)", borderRadius: "100%", minWidth: 48, height: 48, mt: 2, mb: 2, float: "right" }} onClick={() => { navigate('agent_hinzufuegen') }}>
              <SvgIcon>
                <Add />
              </SvgIcon>
            </Button>

          }
        />
      </Box>
      {/* <div>
        <button onClick={() => setShouldRedirect(true)}>Redirect</button>
      </div> */}

      <HolzfinderList
        listLengthTotal={agentListTotal}
        rowData={rowData}
        switchActive={true}
        switchStatus={switchStatus}
        tableHeaderList={tableHeaderList}
        setPage={setPageAgentUsersList}
        setRowsPerPage={setRowsPerPageAgentUsersList}
        page={page}
        rowsPerPage={rowsPerPage}
        link={`/${userRole}/agentenliste/${currentAgentId}/`}
        isLotList={false}
      />
    </Container>
  )
}
